export const projects = [
  {
    title: "Plants vs Zombies API",
    desc: "An API built with with NextTS and Tailwind CSS to help website builders build their websites about Plants-vs-Zombies-2 easily! Data has been scraped from fandom websites and all data are  error free",
    tags: [
      {
        name: "NextJs",
        color: "red-600",
      },
     
      {
        name: "TypeScript",
        color: "yellow-600",
      },
      {
        name: "Clean UI",
        color: "green-600",
      },
      {
        name: "Responsive",
        color: "green-600",
      },
    ],
    img: "https://cdn.discordapp.com/attachments/1096426516667174994/1109025615442608168/pvz.png",
    link: "https://pvz-2-api.vercel.app/",
    code: "https://github.com/ansh1423/plantname",
  },
  {
    title: "Mochi-Shoes",
    desc: "This is an e-commerce website where you can purchase shoes, built using Next.js, and it is also responsive",
    tags: [
      {
        name: "NextJs",
        color: "red-600",
      },
      {
        name: "Javascript",
        color: "red-600",
      },
      {
        name: "Redux",
        color: "green-600",
      },
      {
        name: "Tailwind CSS",
        color: "green-600",
      },
      {
        name: "MongoDB",
        color: "yellow-600",
      },
      {
        name: "NodeJs",
        color: "yellow-600",
      },
      {
        name: "ExpressJs",
        color: "yellow-600",
      },
    ],
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQlje5fHDHvGUqZy4ilm0VbEjBJECgJ1TOqKQ&usqp=CAU",
    link: "https://mochi-shoes.vercel.app/",
    code: "https://github.com/ansh1423/MochiShoes",
  },
  {
    title: "Stock Market",
    desc: "Stock Market Website done with ReactJs as Frontend and Express as Backend. This websites gives practice for people those who want to start using stock market. It is based on realtime update of stock value.",
    tags: [
      {
        name: "ReactJs",
        color: "red-600",
      },
      {
        name: "ExpressJs",
        color: "green-600",
      },
      {
        name: "MongoDB",
        color: "blue-800",
      },
    ],
    img: "https://cdn.discordapp.com/attachments/1096426516667174994/1109032447783469097/image.png",
    link: "https://stock-market-seven.vercel.app/",
    code: "https://github.com/ansh1423/StockMarket",
  },
  {
    title: "Taxi Booking Service",
    desc: "Embark on a futuristic journey with our Taxi Booking Service, driven by the power of Next.js 14 and Hypergraph. Experience lightning-fast performance, dynamic real-time updates, and unparalleled reliability. Revolutionize your travel plans with a seamless fusion of cutting-edge technology for a ride-hailing experience like never before.",
    tags: [
      {
        name: "NextJs 14",
        color: "red-600",
      },
      {
        name: "Hypergraph",
        color: "green-600",
      },
      {
        name: "Tailwind Css",
        color: "blue-800",
      },
    ],
    img: "https://images.unsplash.com/photo-1599278340576-bff6a4c8f3a1?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDB8fHRheGl8ZW58MHx8MHx8fDA%3D",
    link: "https://taxi-booking-5gx2.vercel.app/",
    code: "https://github.com/ansh1423/taxi-booking",
  },
  {
    title: "Education Website",
    desc: "This is the education website. In this website you can find admit card ,result and information of the school.",
    tags: [
      {
        name: "ReactJs",
        color: "red-600",
      },
      {
        name: "Javascript",
        color: "red-600",
      },
      
      {
        name: "Responsive",
        color: "green-600",
      },
      {
        name: "Clean UI",
        color: "green-600",
      },
      {
        name: "TaiwindCSS",
        color: "yellow-600",
      },
      
    ],
    img: "https://media.istockphoto.com/id/1405941823/photo/mother-prepares-to-send-her-son-to-school.webp?b=1&s=612x612&w=0&k=20&c=vuXJxa_JccqxtertlBt8jSxJNHDb7-R6dZyg64UU26E=",
    link: "https://eduwebtech.netlify.app/",
    code: "https://github.com/uttarakhandstateopenschool/uttarakhandstateopenschool-userWeb",
  },
];
